import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n';

/** Сопоставляет текст ошибки бэкенда с сообщением интерфейса; переводится на месте показа. */
export function getGenerateMatchesErrorMessage(error: unknown): MessageDescriptor {
  const message = String(error);

  if (message.includes('Not allowed')) {
    return msg`У вас нет прав для генерации матчей`;
  }
  if (message.includes('Unsupported stage type')) {
    return msg`Автогенерация недоступна для данного типа этапа. Поддерживаются: круговой и групповой форматы`;
  }
  if (message.includes('has no team groups')) {
    return msg`На этапе нет групп команд. Добавьте группы перед генерацией матчей`;
  }
  if (message.includes('Not enough teams') && message.includes('Group')) {
    return msg`В одной из групп меньше 2 команд. Добавьте команды во все группы`;
  }
  if (message.includes('Not enough teams')) {
    return msg`Недостаточно команд на этапе. Добавьте минимум 2 команды`;
  }

  return msg`Ошибка генерации матчей`;
}
